import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { fromGetPreviousAdminsActions } from '../actions';
import { IGetDirectorsPreviousResponse } from '../models/get-directors.model';

export const previousAdminsFeatureKey = 'previousAdmins';

export interface State {
  loadGetPreviousAdminsResponse: IGetDirectorsPreviousResponse[];
  loadGetPreviousAdminsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: State = {
  loadGetPreviousAdminsResponse: undefined,
  loadGetPreviousAdminsFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(fromGetPreviousAdminsActions.loadPreviousBusinessAdministratorsSuccess, (state, action) => ({
    ...state,
    loadGetPreviousAdminsResponse: action.response,
    loaded: true
  })),
  on(fromGetPreviousAdminsActions.loadPreviousBusinessAdministratorsFailure, (state, action) => ({
    ...state,
    loadGetPreviousAdminsFailure: action.error,
    loaded: true
  }))
);

export const getPreviousAdminsResponse = (state: State) => state.loadGetPreviousAdminsResponse;
export const getPreviousAdminsIsLoaded = (state: State) => state.loaded;
